import { SVGProps, Ref, forwardRef } from 'react';

export const LivejournalBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12.693 2.415c-1.452 0-2.831.302-4.092.847L6.338 1A10.33 10.33 0 0 0 1 6.364l2.264 2.262a10.2 10.2 0 0 0-.863 4.089 10.29 10.29 0 0 0 6.364 9.505 10.31 10.31 0 0 0 11.223-2.24 10.29 10.29 0 0 0-7.295-17.565"
                fill="#00B0EA"
            />
            <path
                d="M16.984 11.624a10.34 10.34 0 0 0-5.338 5.364L3.263 8.626a10.33 10.33 0 0 1 5.345-5.364z"
                fill="#15374C"
            />
            <path d="M14.484 17.592a6.01 6.01 0 0 1 3.097-3.117l.811 3.927z" fill="#15374C" />
            <path
                d="m17.581 14.483-.597-2.859a10.34 10.34 0 0 0-5.338 5.364l2.831.604a6.04 6.04 0 0 1 3.097-3.116"
                fill="white"
            />
        </g>
    </svg>
));
LivejournalBrandSize24Glyph.displayName = 'LivejournalBrandSize24Glyph';
